import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import PostcodeSearch from '@stories/Components/PostcodeSearch/PostcodeSearch';
import * as React from 'react';
import S from './FindNearestShowroom.styles';
const FindNearestShowroom = ({ anchorId, title, content, image, form, }) => {
    const srcs = image ? getSrcs(image, 606, 228, 6) : [];
    return (React.createElement(S.Container, { id: anchorId },
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.ContentInner, null,
                React.createElement(S.Title, null, title),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                React.createElement(PostcodeSearch, { ...form })),
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { sizes: `${until(Device.TabletSmall)} 83vw, ${until(Device.DesktopLarge)} 25vw, 398px`, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), alt: image.altText ?? undefined, role: !image.altText ? 'presentation' : undefined, loading: "lazy" }))))));
};
export default FindNearestShowroom;
